import React from 'react';
import { Logo } from './Logo';
import { Phone } from 'lucide-react';
import { Button } from './Button';
export function Header() {
  return <header className="sticky top-0 z-50 w-full bg-neutral-white border-b border-border-default shadow-sm" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-88">
        <a href="#" className="flex-shrink-0" data-id="element-89">
          <Logo width={120} height={40} data-id="element-90" />
        </a>
        <div className="flex items-center gap-4" data-id="element-91">
          <a href="tel:0408247276" className="hidden sm:flex items-center gap-2 text-text-primary-default font-body-semi-bold hover:opacity-80 transition-opacity" data-id="element-92">
            <Phone className="w-5 h-5" data-id="element-93" />
            <span className="text-lg" data-id="element-94">0408 247 276</span>
          </a>
          <a href="tel:0408247276" className="sm:hidden" data-id="element-95">
            <Button variant="primary" size="sm" className="w-full" data-id="element-96">
              <Phone className="w-4 h-4 mr-2" data-id="element-97" />
              Call
            </Button>
          </a>
        </div>
      </div>
    </header>;
}